import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaGithub, FaLinkedin, FaFacebook, FaLinkedinIn } from "react-icons/fa";
import { HiOutlineMail, HiHome  } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
import Logo from "../assets/Logo2.jpg";
import { Link } from "react-scroll";
import { FaHome } from "react-icons/fa";
import { ImFacebook2 } from "react-icons/im";
import { FaTwitterSquare, FaYoutube } from "react-icons/fa";
 

const Navbar = () => {

  const menuBtn = "bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"

  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  const [top, setTop] = useState(true);
  // detect whether user has scrolled the page down by 10px
  const scrollHandler = () => {
    window.pageYOffset > 10 ? setTop(false) : setTop(true);
  };

  useEffect(() => {
    scrollHandler();
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [top]);

  return (
    <>
      <header
        className={`fixed w-full h-[80px] flex justify-between items-center px-4 z-30 bg-opacity-70 transition duration-300 ease-in-out bg-white backdrop-blur-sm ${
          !top ? "shadow-lg" : "shadow-sm"
        }`}
      >
        {/* <div className="fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300"> */}
        <div className="flex mx-10 text-5xl text-center">
          <span>
            <Link to="home" smooth={true} duration={500}>
              <img src={Logo} alt="Logo Image" style={{ width: "60px" }} />
            </Link>
          </span>
          <Link to="home" smooth={true} duration={500}>
            <h1 className="mx-5 sm:text-3xl  text-lg font-bold text-fuchsia-700 font-sans">Haryana Library Association</h1>
          </Link>
        </div>

        {/* menu */}
        <ul className="hidden md:flex text-xs">
          <li>
            <Link to="home" 
            // className="text-blue-600 hover:text-blue-800 visited:text-purple-600" 
            className="inline-block bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded visited:text-purple-600"             
            smooth={true} duration={500}>
                <HiHome size={15} />
            </Link>
          </li> 
          <li>
            <Link to="about" smooth={true} duration={500} className="inline-block bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded visited:text-purple-600">
              About
            </Link>
          </li>
          <li>
            <Link to="notices" smooth={true} duration={500} className="inline-block bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded visited:text-purple-600">
            Notices
            </Link>
          </li>
          <li>
            <Link to="officebearer" smooth={true} duration={500} className="inline-block bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded visited:text-purple-600">
            Office-Bearer
            </Link>
          </li>
          <li>
            <Link to="hlapresidents" smooth={true} duration={500} className="inline-block bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded visited:text-purple-600">
            HLA-Presidents
            </Link>
          </li>
          <li>
            <Link to="download" smooth={true} duration={500} className="inline-block bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded visited:text-purple-600">
            Download
            </Link>
          </li>
          <li>
            <Link to="contact" smooth={true} duration={500} className="inline-block bg-fuchsia-700 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded visited:text-purple-600">
              Contact
            </Link>
          </li>
        </ul>

        {/* Hamburger */}
        <div onClick={handleClick} className="md:hidden z-10">
          {!nav ? <FaBars /> : <FaTimes />}
        </div>

        {/* Mobile menu */}
        <ul
          className={
            !nav
              ? "hidden" 
              //: "absolute top-0 left-0 w-3/5 h-screen flex flex-col justify-center items-center bg-opacity-90 overflow-y-auto transition-transform -translate-x-full bg-white dark:bg-gray-800"
               : "text-2xl absolute top-0 left-0 w-3/5 h-screen flex flex-col justify-center items-center bg-opacity-90 transition duration-300 ease-in-out bg-white backdrop-blur-sm shadow-lg"
          }
        >
          <li className="py-6">
            <Link onClick={handleClick} to="home" smooth={true} duration={500}>
            <HiHome size={30} />
            </Link>
          </li>
          <li className="py-6"> 
            <Link onClick={handleClick} to="about" smooth={true} duration={500}>
              About
            </Link>
          </li>
          <li className="py-6"> 
            <Link onClick={handleClick} to="officebearer" smooth={true} duration={500}>
            Office-Bearer
            </Link>
          </li>
          <li className="py-6"> 
            <Link onClick={handleClick} to="hlapresidents" smooth={true} duration={500}>
            HLA-Presidnets
            </Link>
          </li>
          <li className="py-6"> 
            <Link onClick={handleClick} to="download" smooth={true} duration={500}>
            Download
            </Link>
          </li>
          <li className="py-6"> 
            <Link onClick={handleClick} to="contact" smooth={true} duration={500}>
              Contact
            </Link>
          </li>
        </ul>

        {/* </div> */}
      </header>
      {/* Social icons */}
      <div className="hidden lg:flex fixed flex-col top-[35%] left-0 z-30">
        <ul>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600">
            <a className="flex justify-between items-center w-full text-gray-300" target="_blank" href="https://www.facebook.com/hlaharyana">
            Facebook <ImFacebook2 size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]">
            <a className="flex justify-between items-center w-full text-gray-300" target="_blank" href="https://twitter.com/hlaharyana?lang=en">
            Twitter <FaTwitterSquare size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0]">
            <a className="flex justify-between items-center w-full text-gray-300" href="mailto:haryanalibraryassociation@gmail.com">
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#ed4779]">
            <a className="flex justify-between items-center w-full text-gray-300" target="_blank" href="/">
              Youtube <FaYoutube size={30} />
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
